import React, { useEffect, useState } from "react";
import "./Section2.css";
import smartBoy from "../../Assets/smart boy.png";
import journeyImage2 from "../../Assets/pg2Back.png";
import websiteDevelopment from "../../Assets/Fullstack.jpeg";
import Artificial from "../../Assets/AI.jpeg";
import User from "../../Assets/UIUX.jpeg";
import Digital from "../../Assets/Digitalmarketing.jpeg";
import journeyImage4 from "../../Assets/pg2back3.jpg";



// Sample descriptions: replace each text with the final copy for its image.
const journeyImages = [
  {
    src: websiteDevelopment,
    alt: "website development image",
    description: "Every journey begins with curiosity and a desire to learn. Explore new ideas, build your understanding, and take the first steps toward the future you want to create.",
  },
  {
    src: Artificial,
    alt: "EMEI journey image 2",
    description: "Turn curiosity into practice. Discover how learning through experience can bring ideas to life, strengthen your skills, and give you the confidence to try something new.",
  },
  {
    src: User,
    alt: "EMEI journey image 3",
    description: "Keep growing through shared ideas and fresh perspectives. Learn alongside others, explore different approaches, and make every challenge an opportunity to move forward.",
  },
  {
    src: websiteDevelopment,
    alt: "EMEI journey image 4",
    description: "Look ahead to the next chapter of your journey. Carry your knowledge and experience forward as you discover new possibilities and work toward your goals.",
  },
  {
    src: websiteDevelopment,
    alt: "EMEI journey image 4",
    description: "Look ahead to the next chapter of your journey. Carry your knowledge and experience forward as you discover new possibilities and work toward your goals.",
  },
   {
    src: websiteDevelopment,
    alt: "EMEI journey image 4",
    description: "Look ahead to the next chapter of your journey. Carry your knowledge and experience forward as you discover new possibilities and work toward your goals.",
  },

];

function JourneyImage({ index, animate }) {
  const image = journeyImages[index];
  const previous = journeyImages[(index + journeyImages.length - 1) % journeyImages.length];

  return (
    <div className={`journey-image-frame${animate ? " is-sliding" : ""}`}>
      {animate && (
        <img className="journey-image-outgoing" src={previous.src} alt="" aria-hidden="true" />
      )}
      <img className="journey-image-current" src={image.src} alt={image.alt} />
    </div>
  );
}

export default function Section2() {
  const [step, setStep] = useState(0);
  const activeIndex = step % journeyImages.length;

  useEffect(() => {
    const timer = window.setInterval(() => {
      setStep((previousStep) => previousStep + 1);
    }, 3500);

    return () => window.clearInterval(timer);
  }, []);

  return (
<section
  className="section-container"
  data-aos="fade-up"
  data-aos-duration="650"
  data-aos-delay="50"
  data-aos-once="true"
>
  <div className="content-wrapper">

    {/* TOP TEXT */}
    <div
      className="upper-content"
      data-aos="fade-up"
      data-aos-duration="600"
      data-aos-delay="100"
      data-aos-once="true"
    >
      <h1
        className="main-title"
        data-aos="fade-right"
        data-aos-duration="600"
        data-aos-delay="150"
        data-aos-once="true"
      >
        The Professional Courses we Offers
      </h1>

      <p
        className="description-text"
        data-aos="fade-up"
        data-aos-duration="600"
        data-aos-delay="220"
        data-aos-once="true"
      >
       Professional courses are designed to provide students with practical knowledge, industry-relevant skills, and career-focused training. Unlike purely theoretical education, these courses focus on developing the abilities that students need to perform effectively in real-world professional environments.

Our professional courses cover a wide range of modern and in-demand skills, including Advanced Excel, Tally with GST, SAP, Digital Marketing, SEO, Python, Machine Learning, Cyber Security, Web Development, Data Analytics, Accounting, Taxation, and Professional Spoken English. Each course is structured to help learners understand concepts clearly and apply them through practical exercises and real-world examples.In today's competitive job market, having a degree is often not enough. Employers also look for candidates who possess practical skills, technical knowledge, communication abilities, and professional confidence. Professional training helps students bridge the gap between academic learning and workplace requirements.
      </p>
    </div>

    {/* MAIN */}
    <div
      className="custom-layout journey-slider"
      role="region"
      aria-roledescription="carousel"
      aria-label="The journey of EMEI"

    >

      {/* IMAGE */}
      <div
        className="left-image"
        data-aos="fade-right"
        data-aos-duration="700"
        data-aos-delay="150"
        data-aos-once="true"
      >
        <JourneyImage key={step} index={activeIndex} animate={step > 0} />
      </div>

      {/* OVERLAPPING RIGHT SIDE */}
      <div
        className="right-content"
        data-aos="fade-left"
        data-aos-duration="700"
        data-aos-delay="250"
        data-aos-once="true"
      >

        <div className="color-box-row">
          {[1, 2, 3].map((offset) => {
            const imageIndex = (activeIndex + offset) % journeyImages.length;

            return (
              <div key={offset} className="color-box">
                <JourneyImage key={step} index={imageIndex} animate={step > 0} />
              </div>
            );
          })}
        </div>

        <div
          className="text-content"
          data-aos="fade-up"
          data-aos-duration="600"
          data-aos-delay="350"
          data-aos-once="true"
        >
          <div className="journey-captions" aria-live="off">
            {journeyImages.map((image, index) => (
              <p
                key={image.src}
                className={`journey-caption${index === activeIndex ? " is-active" : ""}`}
                aria-hidden={index !== activeIndex}
              >
                {image.description}
              </p>
            ))}
          </div>
        </div>

      </div>
    </div>

  </div>
</section>
  );
}
